import { put, call, select } from 'redux-saga/effects'
import { reset } from 'redux-form'
import { push } from 'connected-react-router'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { userActions } from 'reduxModules/actions/UserActions'
import { phonetActions } from 'reduxModules/actions/PhonetActions'
import { companySelector, isPrexBusSelector } from 'reduxModules/selectors/UserSelectors'

import { createDateId, createMonthAgo } from 'services/helpers'
import { createUser, deleteUser } from 'services/api'
import { confirmSaga } from 'services/sagaHelpers'
import { rsf, firebase, firestore } from '../../firebase'
import { BOOK } from 'constants/urls'

export function* getUserDataSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const res = yield call(rsf.firestore.getDocument, `users/${data}`)

    if (!res.data()) {
      return yield put(responseFailure())
    }

    yield put(responseSuccess({ uid: res.id, ...res.data() }))

    yield put(push(BOOK))

    const isPrexBus = yield select(isPrexBusSelector)

    if (isPrexBus) {
      yield put(phonetActions.subscribeToCall())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
  }
}

export function* getUserHistorySaga(action) {
  const { responseSuccess, responseFailure, data: uid } = action

  try {
    const monthAgo = createMonthAgo()

    const colRef = yield firestore.collection(`users/${uid}/history`)
    const query = yield colRef.where('lastModified', '>=', monthAgo)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const history = []

      res.forEach(item => history.push({ id: item.id, ...item.data() }))

      yield put(responseSuccess(history))
    } else {
      yield put(responseSuccess([]))
      yield put(snackbarActions.showSnackbar({
        type: 'error',
        message: 'Для даного користувача історія відсутня'
      }))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час заванитаження історії користувача'
    }))
  }
}

export function* setUserHistorySaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const { uid, metadata } = data
    const lastSignInTime = new Date(metadata.lastSignInTime)
    const dayId = createDateId(lastSignInTime)
    const docData = {
      lastModified: firebase.firestore.FieldValue.serverTimestamp(),
      lastSignInTime: firebase.firestore.FieldValue.arrayUnion(lastSignInTime)
    }

    yield call(rsf.firestore.setDocument, `users/${uid}/history/${dayId}`, docData, { merge: true })

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
  }
}

export function* setUserLineIdSaga(action) {
  const { responseSuccess, responseFailure, data: { uid, lineId } } = action

  try {
    yield call(
      rsf.firestore.setDocument,
      `users/${uid}`,
      { lineId },
      { merge: true }
    )

    yield put(responseSuccess({ uid, lineId }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
  }
}

export function* deleteUserSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const confirmed = yield call(confirmSaga, 'deleteUser')

    if (confirmed) {
      yield call(deleteUser, data)

      yield put(responseSuccess(data.uid))
      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Користувач успішно видалений'
      }))
    }

    yield put(responseFailure())
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час видалення користувача'
    }))
  }
}

export function* getUsersSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const company = yield select(companySelector)
    const isPrexBus = yield select(isPrexBusSelector)
    const query = isPrexBus
      ? firestore
        .collection('users')
      : firestore
        .collection('users')
        .where("company", "==", company)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const users = []

      res.forEach(user => users.push({ id: user.id, ...user.data() }))

      yield put(responseSuccess(users))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час бронювання заванитаження користувачів'
    }))
  }
}

export function* createUserSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const company = yield select(companySelector)

    const res = yield call(createUser, {
      ...data,
      company
    })

    if (res.ok) {
      yield put(reset('createUser'))
      yield put(responseSuccess(data))
      yield put(userActions.getUsers())
      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Користувач успішно добавлений'
      }))

      return
    }

    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час добавлення користувача'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час добавлення користувача'
    }))
  }
}

export function* resetUserPasswordSaga(action) {
  const { responseSuccess, responseFailure, data: email } = action

  try {
    yield call(rsf.auth.sendPasswordResetEmail, email)

    yield put(responseSuccess())
    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Пароль успішно скинуто'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час скидування пароля'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/UserSagas.js